module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-static"
  }, _vm._l((_vm._actions), function(b, idx) {
    return _c('el-button', {
      staticClass: "btn",
      class: b.class,
      on: {
        "click": function($event) {
          _vm.click(b, idx)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.isArray(b.label) ? _vm.i18n.fr.apply(_vm.i18n, b.label) : _vm.i18n.fr(b.label)) + "\n    "), (_vm.processing === idx) ? _c('i', {
      staticClass: "ti-reload ti-spin"
    }) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fbf4dd7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-button.vue
// module id = 538
// module chunks = 55